<template>
    <div class="home">
    <!-- SLIDER -->
    <home-slider></home-slider>
    <!-- SERVICIOS -->
    <home-servicios></home-servicios>
    <!-- SUSCRIPCION -->
    <div id="suscripcion">
        <div class="container">
            <div class="row">
                <div class="col-md-6">
                    <div>
                        <h2 class="align-middle">Ingrese su mail y reciba m&aacute;s info</h2>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="input-group centrado">
                        <input type="email" class="form-control" placeholder="e-mail" v-model="mail">
                        <span class="input-group-btn">                                         
                            <button class="btn btn-outline-secondary" type="button" @click="enviarSuscripcion">SUSCRIBIRME</button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
      <!-- BLOG -->
    <blog></blog>
    </div>
</template>

<script>

import Blog from './Blog'
import HomeSlider from './Home-Slider'
import HomeServicios from './Home-Servicios'

import { Suscribir } from '../services/website/website.service.js' 

export default {
    name: 'home',
    components: {
        HomeSlider,
        HomeServicios,
        Blog,
    },

    data () {
        return {
          mail: null
        }
    },
    
    methods: {
        enviarSuscripcion() {
            var result = Suscribir(this.mail)

            if (result.estado == false) {
              this.$notie.alert(3, 'Ingrese un E-mail valido.' , 2)
            }
            else {
              this.$notie.alert(1, 'Registro exitoso.' , 2)
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
      font-weight: normal;
    }

    ul {
      list-style-type: none;
      padding: 0;
    }

    li {
      display: inline-block;
      margin: 0 10px;
    }

    a {
      color: #42b983;
    }

    span {
      padding-left: 20px;
    }

    input.form-control {
      border-radius: 0;
    }

    .btn {
      border : 0;
      padding: 10px;
      border-radius: 0;
    }

    .input-group {
      width: 80%;
    }

    ::-webkit-input-placeholder {
      font-style: italic;
    }

</style>



// WEBPACK FOOTER //
// Home.vue?3bdb7b1a